/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from '@vlinder-web/plugin-agent-service-react';

import {
  StaticContentPlugin,
  IStaticContentPluginMethods,
  LoadingContentPlugin,
  ILoadingContentPluginMethods,
  ErrorContentPlugin,
  IErrorContentPluginMethods,
  IFormatTimelineDetailMethods,
  FormatTimelineDetailPlugin,
  IHeaderMethods,
  HeaderPlugin,
  INomineeDetailMethods,
  NomineeDetailPlugin,
  IUpdateBankDetailMethods,
  UpdateBankDetailsPlugin,
} from './plugins';

export type TAgent = IStaticContentPluginMethods &
  ILoadingContentPluginMethods &
  IErrorContentPluginMethods &
  IFormatTimelineDetailMethods &
  IHeaderMethods &
  IUpdateBankDetailMethods &
  INomineeDetailMethods;

const getPlugins = () => {
  return [
    new StaticContentPlugin(),
    new ErrorContentPlugin(),
    new LoadingContentPlugin(),
    new FormatTimelineDetailPlugin(),
    new HeaderPlugin(),
    new NomineeDetailPlugin(),
    new UpdateBankDetailsPlugin(),
  ];
};

export const getAgent = () => {
  return createAgent<TAgent>({
    plugins: getPlugins(),
  });
};
